import { render, staticRenderFns } from "./SmsChargeModal.vue?vue&type=template&id=5ffdf764&"
import script from "./SmsChargeModal.vue?vue&type=script&lang=js&"
export * from "./SmsChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports